









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseActivity from '@/components/administration/activity/edit/EditBaseActivity.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloActivity } from '@/models/alo/AloActivity'
import { AloActivity } from '@/models/alo/AloActivity'

@Component({
  name: 'EditContent',     
  components:{EditBaseActivity}
})
export default class EditContent extends Vue {
      
  private activity:AloActivity = getDefaultAloActivity()

  edit(item:AloActivity) {            
    this.activity = (this.$refs.baseEdit as EditBaseActivity).edit(item)    
  }
  

  get configuration(){
    return this.$store.myGetters.configuration
  }
  
  private get editorConfig(){
    return {...this.configuration.editorDefaultConfig,height:350}
  }  

  private get editorConfigHat(){
    return {...this.configuration.editorDefaultConfig,height:100}
  }  
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
